<app-content-body class="h-100 px-3" style="margin-top: 45px;">
    <app-breadcrumbs></app-breadcrumbs>
    <app-content-heading [icon]='faCloud' class="pt-2" [title]="title" [registerPage]="true"></app-content-heading>
    <app-wizard-layout [wizardTabs]='wizardTabs' class="h-100" (currentIndexEmitter)="onWizardTabChange($event)"
        [currentIndex]="tabIndex">
        <div sample>
            <app-select-plan 
                [isLoadingPlans]="this.isLoadingPlans"
                [subscriptionId]="subscriptionId"
                [subscriptionPlans]="this.subscriptionPlans" 
                [selectedPlan]="this.selectedPlan"
                *ngIf="wizardTabs[tabIndex] == PlanAction.SelectPlan"
                (onPlanSelection)="onPlanSelection($event)"
                (updateWizardStep)="onWizardTabChange($event)">
            </app-select-plan>

            <app-view-selected-plan
                [cloudVendor]="cloudVendor"
                [tabIndex]="this.tabIndex"
                [subscriptionId]="this.subscriptionId" 
                *ngIf="wizardTabs[tabIndex] == PlanAction.Confirmation"
                [selectedPlan]="selectedPlan"
                [period]="this.period"
                (updateWizardStep)="onWizardTabChange($event)">
            </app-view-selected-plan>
        </div>
    </app-wizard-layout>
</app-content-body>